import { AxiosGetRequestOptions, AxiosPutRequestOptions } from '@/package';
import type { TrackApi } from '@/type';
import { apiOf } from '@/util';

export const getTrackByFrameSeq = apiOf<
  TrackApi.GetTrackByFrameSeq.Request,
  TrackApi.GetTrackByFrameSeq.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/task/:taskID/track/:trackID',
  }),
);

export const updateExpireTime = apiOf<
  TrackApi.UpdateExpireTime.Request,
  TrackApi.UpdateExpireTime.Response
>(
  new AxiosPutRequestOptions({
    url: '/v1/miri/task/:taskID/frame/:frameSeq/trackSession/:trackSessionID/extend?leaveFrame=:leaveFrame',
    defaultQuery: {
      leaveFrame: false,
    },
  }),
);

export const updateTrackID = apiOf<
  TrackApi.UpdateTrackID.Request,
  TrackApi.UpdateTrackID.Response
>(
  new AxiosPutRequestOptions({
    url: '/v1/miri/task/:taskID/track/:trackID',
  }),
);
